import React from "react";
import Headline from "../../atoms/headline";

import "./get-app.m.css";

const getPwaPopup = () => {
  document.getElementById("sw-wrapper").style.display = "block";
};

function GetAppPage() {
  return (
    <div styleName="wrapper">
      <div styleName="header">
        <Headline text="Mobile and Desktop Applications" headerType={12} headerLevel={1} />
      </div>
      <div styleName="get-app">
        <div styleName="item">
          <Headline text="For iOS Mobiles & Tablets" headerType={2} headerLevel={3} />
          <a
            id="app-download-ios"
            rel="noopener noreferrer"
            target="_blank"
            href="https://apps.apple.com/in/app/free-press-journal/id954819143"
          >
            <img
              alt="Get it on AppStore"
              src="https://images.assettype.com/freepressjournal/2019-11/17dbd466-7b4a-49ac-af83-176179d09965/appStore.png"
              height="40px"
            />
          </a>
        </div>
        <div styleName="item">
          <Headline text="For Android Mobiles & Tablets" headerType={2} headerLevel={3} />
          <a
            id="app-download-android"
            target="_blank"
            rel="noopener noreferrer"
            href="https://play.google.com/store/apps/details?id=com.readwhere.whitelabel.freepressjournal&hl=en&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
          >
            <img
              alt="Get it on Google Play"
              src="https://images.assettype.com/freepressjournal/2019-11/6a2d6d18-1b86-4b46-870a-cb46c6037087/playStore.png"
              height="40px"
            />
          </a>
        </div>
        <div styleName="item">
          <Headline text="For Mobiles, Tablets & Dekstops" headerType={2} headerLevel={3} />
          <a id="app-download-pwa" styleName="link" onClick={() => getPwaPopup()}>
            <img
              alt="Get it on Google Play"
              src="https://images.assettype.com/freepressjournal/2019-11/9381269f-b359-4c17-bfab-012975ba5524/pwa.png"
              height="40px"
            />
          </a>
        </div>
      </div>
    </div>
  );
}

export { GetAppPage };
